import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Box from '@material-ui/core/Box';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

class TableHeaderEnhance extends Component {
  createSortHandler = (property) => (event) => {
    const { onRequestSort } = this.props;
    onRequestSort(event, property);
  };

  render() {
    const {
      order, orderBy, columnData, firstColumnSticky,
    } = this.props;

    return (
      <TableHead>
        <TableRow>
          {columnData.map((column, i) => {
            if (column.sortable) {
              if (column.hidden) {
                return null;
              }

              return (
                <TableCell
                  key={column.id}
                  align={column.align ? column.align : 'left'}
                  padding={column.disablePadding ? 'none' : 'default'}
                  sortDirection={orderBy === column.id ? order : false}
                  className={firstColumnSticky && i === 0 ? 'first-table-sticky-head' : ''}
                  style={i === 0 ? { zIndex: 4 } : {}}
                >
                  <Tooltip
                    title="เรียงลำดับ"
                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                    enterDelay={300}
                    // style={{ paddingLeft: 15 }}
                  >
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={order}
                      onClick={this.createSortHandler(column.id)}
                      style={{ minWidth: column.minWidth ? column.minWidth : '' }}
                    >
                      <Box display="block">
                        <Box>
                          <Typography variant="subtitle2" noWrap>
                            {column.label}
                          </Typography>
                        </Box>
                        {column.unit && (
                          <Box>
                            <Typography variant="caption" noWrap display="block">
                              {column.unit}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </TableSortLabel>
                  </Tooltip>
                </TableCell>
              );
            }

            return (
              <TableCell key={column.id} align={column.align ? column.align : 'left'}>
                {column.label}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

TableHeaderEnhance.defaultProps = {
  firstColumnSticky: false,
};

TableHeaderEnhance.propTypes = {
  columnData: PropTypes.instanceOf(Array).isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  firstColumnSticky: PropTypes.bool,
  // theme: PropTypes.object.isRequired,
};

export default TableHeaderEnhance;
